import styled from 'styled-components'

export const Container = styled.div `
    height: 100%;
    .top{
        margin-bottom: 10px;
    }
    .bottom{
        height: calc(100% - 42px);
        overflow-y: scroll;
    }

  .ant-tabs-nav .ant-tabs-tab-active{
    font-weight: 700;
  }
  .ant-tabs-nav-scroll{
    font-weight: 600;
    margin-top: -14px!important;
  }
  .ant-tabs-bar{
    background-color: #FFFFFF!important;
  }
`